import {Controller} from "stimulus"

export default class extends Controller {

    getData(event) {
        const offset = event.target.value
        const url = `${event.target.dataset.url}&offset=${offset}`
        this.loadData(url);
    }

    orderViews() {
        const value = event.target.value
        if (value > 30) {
            window.location.href = event.target.dataset.url;
        }
    }

    seeAll(event) {
        const offset = 365 * 10; // 10 years
        const url = `${event.target.dataset.url}&offset=${offset}`
        this.loadData(url);
    }

    loadData(url) {
        const fullUrl = new URL(url, window.location.origin);
        const params = new URLSearchParams(fullUrl.search);
        const type = params.get('type');

        let elem = document.querySelector(`#${type}`);
        let collapseEl = this.element.querySelector('[aria-expanded="false"]')
        elem.style.opacity = 0.5;

        if (collapseEl) {
            collapseEl.click();
        }

        fetch(fullUrl, {
            method: 'POST',
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
            .then(res => res.text())
            .then(html => {
                elem.innerHTML = html;
                elem.style.opacity = 1;
            });
    }
}